import { PaymentStatus } from '../../resources/constants/PaymentStatus'

export const DotState = {
	running: 'running',
	blank: 'blank',
	valid: 'valid',
	warning: 'warning',
	error: 'error'
}

const StatusGroupMap = {
	SCHEDULED: {
		isFinal: false,
		statusList: [PaymentStatus.SCHEDULED, PaymentStatus.INITIATED, PaymentStatus.PENDING],
		translation: 'InProgress'
	},
	INITIATED_SEPA: {
		isFinal: true,
		statusList: [PaymentStatus.INITIATED_SEPA],
		translation: 'Sent'
	},
	PROCESSING: {
		isFinal: false,
		statusList: [
			PaymentStatus.SENT,
			PaymentStatus.ACCEPTED,
			PaymentStatus.PROCESSING_PARTNER,
			PaymentStatus.PROCESSING_INTERMEDIARY,
			PaymentStatus.PROCESSING_BENEFICIARY
		],
		translation: 'InProgress'
	},
	UNAVAILABLE: {
		isFinal: true,
		statusList: [PaymentStatus.PROCESSING_NO_TRACKING],
		translation: 'NoTracking'
	},
	COMPLETED: {
		isFinal: true,
		statusList: [PaymentStatus.COMPLETED],
		translation: 'Arrived'
	},
	RETURNED: {
		isFinal: true,
		statusList: [PaymentStatus.RETURNED],
		translation: 'Returned'
	},
	REJECTED: {
		isFinal: true,
		statusList: [PaymentStatus.REJECTED, PaymentStatus.BLOCKED],
		translation: 'Cancelled'
	},
	CANCELED: {
		isFinal: true,
		statusList: [PaymentStatus.CANCELED, PaymentStatus.REFUSED],
		translation: 'Cancelled'
	}
}

export const findStatusGroupNameByStatusKey = (statusKey) => {
	return Object.keys(StatusGroupMap).find((key) =>
		StatusGroupMap[key].statusList.find(
			(groupedStatus) => groupedStatus.statusName === PaymentStatus[statusKey].statusName
		)
	)
}

export default StatusGroupMap
